<template>
    <div>
        <template v-if="width < 2054 && width > 1699">
            <vs-row justify="flex-end">
                <vs-col :key="index" v-for="(col, index) in 3" w="2"><br /></vs-col>
            </vs-row>
        </template>
        <vx-card title="외래치료실관리">
            <div class="flex justify-end flex-wrap">
                <vs-chip color="primary">
                    <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" @click="openPopupFun(9999)" />
                    <span>+ 외래치료실등록</span>
                </vs-chip>
            </div>
            <div class="vx-row mb-3">
                <div class="vx-col w-full">
                    <vs-input class=" w-auto" icon="search" placeholder="검색내용을 입력해주세요." v-model="search" @keyup.enter="treatmentRoomList" />
                </div>
            </div>
            <vs-table :max-items="cutPage" :data="list" :noDataText="'데이터가 존재하지 않습니다.'">
                <template slot="thead">
                    <vs-th class="table_header" width="20%">치료실명</vs-th>
                    <vs-th class="table_header" width="25%">담당자</vs-th>
                    <vs-th class="table_header" width="30%">직통전화(내선번호)</vs-th>
                    <vs-th class="table_header" width="20%">관리</vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr v-for="(tr, index) in data" :key="index">
                        <vs-td>{{ tr.MEDICAL_NM }}</vs-td>
                        <vs-td>{{ tr.MANAGER_NM }}</vs-td>
                        <vs-td>{{ tr.MANAGER_TEL }}</vs-td>
                        <vs-td>
                            <vs-chip color="primary">
                                <vs-avatar color="primary" icon-pack="feather" icon="icon-edit-2" @click="openPopupFun(index)" />
                                <span>수정</span>
                            </vs-chip>
                            <vs-chip color="danger">
                                <vs-avatar color="danger" icon-pack="feather" icon="icon-x" @click="removeTreatmentRoomConfirm(index)" />
                                <span>삭제</span>
                            </vs-chip>
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
            <br />
            <vs-pagination :total="pageCount" v-model="curPage" @input="treatmentRoomList" :max="7"></vs-pagination>
        </vx-card>
        <vs-popup title="외래치료실 등록 및 수정" :active.sync="openPopup">
            <form>
                <input type="hidden" v-model="medicalCode" />
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-input class="w-full" name="" label="외래치료실명" placeholder="외래치료실을 입력해주세요." v-model="medicalName" ref="medicalName" />
                        <span class="text-danger text-sm" v-if="flag1">외래치료실명 입력해주세요.</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-input class="w-full" name="" label="담당자" placeholder="담당자명을 입력해주세요." v-model="managerName" ref="managerName" />
                        <span class="text-danger text-sm" v-if="flag2">담당자를 입력해주세요.</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-input class="w-full" name="" label="직통전화" placeholder="직통전화 입력해주세요." v-model="managerTel" ref="managerTel" />
                        <span class="text-danger text-sm" v-if="flag3">직통전화 입력해주세요.</span>
                    </div>
                </div>
                <div class="vx-row mb-6">
                    <div class="vx-col w-full">
                        <vs-textarea class="w-full" name="" label="메모" placeholder="메모 입력해주세요." v-model="medicalMemo" ref="medicalMemo" />
                        <span class="text-danger text-sm" v-if="flag4">메모 입력해주세요.</span>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full text-right">
                        <vs-button class="mr-3 mb-2" @click="save">저장</vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click="openPopup = false">닫기</vs-button>
                    </div>
                </div>
            </form>
        </vs-popup>
    </div>
</template>

<script>
import axiosClass from '@/../util/axiosClass';
export default {
    data() {
        return {
            search: '',
            curPage: 1,
            cutPage: 7,
            list: [],
            pageCount: 0,
            openPopup: false,
            medicalName: '',
            managerName: '',
            managerTel: '',
            medicalMemo: '',
            flag1: false,
            flag2: false,
            flag3: false,
            flag4: false,
            medicalCode: '',
            gubun: '03',
            width: window.innerWidth,
        };
    },
    methods: {
        handleResize(event) {
            this.width = window.innerWidth;
        },
        init() {
            //this.treatmentRoomList();
        },
        async treatmentRoomList() {
            let sendData = {
                curPage: this.curPage,
                cutPage: this.cutPage,
                search: this.search,
                gubun: this.gubun,
            };
            const { data } = await axiosClass.get('/api/management/medicalSettingRoom', sendData, true);
            // console.log(data);
            if (data.success) {
                this.list = data.list;
                const maxPage = Math.floor(data.list[0].ALL_COUNT / this.cutPage);
                this.pageCount = maxPage < 1 ? 1 : maxPage;
            }
        },
        async openPopupFun(index = 9999) {
            this.flag1 = false;
            this.flag2 = false;
            this.flag3 = false;
            this.flag4 = false;
            if (index == 9999) {
                this.medicalCode = '';
                this.medicalName = '';
                this.managerName = '';
                this.managerTel = '';
                this.medicalMemo = '';
            } else {
                const item = this.list[index];
                this.medicalCode = item.MEDICAL_CD;
                this.medicalName = item.MEDICAL_NM;
                this.managerName = item.MANAGER_NM;
                this.managerTel = item.MANAGER_TEL;
                this.medicalMemo = item.MEMO;
            }
            this.openPopup = true;
        },
        //삭제 확인
        removeTreatmentRoomConfirm(index) {
            const medicalName = this.list[index].MEDICAL_NM;
            this.medicalCode = this.list[index].MEDICAL_CD;
            let _this = this;
            _this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: '삭제',
                text: '해당 치료실(' + medicalName + ')를 정말로 삭제하시겠습니까?',
                acceptText: '삭제',
                cancelText: '취소',
                accept: _this.removeTreatmentRoom,
            });
        },
        async removeTreatmentRoom() {
            let sendData = {
                medicalCode: this.medicalCode,
            };
            try {
                const { data } = await axiosClass.delete('/api/management/medicalCode', sendData, true);
                if (data.result.MSG == 'OK') {
                    this.$vs.notify({
                        color: 'primary',
                        title: '삭제완료',
                        text: '치료실이 삭제되었습니다.',
                        position: 'top-right',
                        iconPack: 'feather',
                    });
                    this.treatmentRoomList();
                    this.openPopup = false;
                } else if (data.result.MSG == 'OVER_SCHEDULE') {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'error',
                        text: '해당 치료실은 병동스케줄에 배정이 되어있어 삭제할 수 없습니다.',
                        position: 'top-right',
                        iconPack: 'feather',
                    });
                }
            } catch (e) {
                console.log(e);
            }
        },
        //치료실 추가 및 수정
        async save() {
            if (this.medicalName.trim() == '') {
                this.flag1 = true;
                return;
            } else if (this.managerName.trim() == '') {
                this.flag2 = true;
                return;
            }
            // else if (this.managerTel.trim() == '') {
            //     this.flag3 = true;
            //     return;
            // } else if (this.medicalMemo.trim() == '') {
            //     this.flag4 = true;
            //     return;
            // }
            let sendData = {
                gubun: this.gubun,
                medicalCode: this.medicalCode,
                medicalName: this.medicalName,
                managerName: this.managerName,
                managerTel: this.managerTel,
                medicalMemo: this.medicalMemo,
            };
            const { data } = await axiosClass.post('/api/management/medicalModify', sendData, true);
            if (data.success) {
                this.$vs.notify({
                    color: 'primary',
                    title: '저장완료',
                    text: '치료실이 저장되었습니다.',
                    position: 'top-right',
                    iconPack: 'feather',
                });
                this.treatmentRoomList();
                this.openPopup = false;
            }
        },
    },

    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.init();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
};
</script>

<style></style>
